import { LocationInfo } from '@Engage.Data/models';
import { LocalStorageService } from '@Engage.Data/services';
import { CookiesStorageService } from '@Engage.Data/services';
import { StorageKeys } from '@Engage.Data/constants/Constants';
import { logService } from '@Core/logger';
class GlobalLocationClass {
    constructor() {
        this.locationData = null;
        this.serviceUrl = window.location.protocol +
            "//api-mg2.db-ip.com/v2/p14891b727f063924f0d86d8a8e5063678abd2ac/self";
    }
    hasFingerprint() {
        return window.Fingerprint &&
            typeof window.Fingerprint.getGlobalLocation === "function";
    }
    saveToStorage(data) {
        var _a;
        try {
            LocalStorageService.set(StorageKeys.GlobalLocation, data);
        }
        catch (err) {
            (_a = logService === null || logService === void 0 ? void 0 : logService.error) === null || _a === void 0 ? void 0 : _a.call(logService, "[GlobalLocation] Failed to save", err);
        }
    }
    getFromStorage() {
        try {
            const data = LocalStorageService.get(StorageKeys.GlobalLocation);
            return data ? new LocationInfo(data) : null;
        }
        catch (_a) {
            return null;
        }
    }
    async fingerprintFlow() {
        var _a, _b;
        try {
            const fp = window.Fingerprint;
            if (!(fp === null || fp === void 0 ? void 0 : fp.getGlobalLocation))
                throw new Error("Fingerprint unavailable");
            const geoData = await fp.getGlobalLocation();
            const location = new LocationInfo(geoData);
            this.locationData = location;
            this.saveToStorage(location);
            (_a = logService === null || logService === void 0 ? void 0 : logService.log) === null || _a === void 0 ? void 0 : _a.call(logService, "[GlobalLocation] Loaded location via Fingerprint");
            return location;
        }
        catch (err) {
            (_b = logService === null || logService === void 0 ? void 0 : logService.error) === null || _b === void 0 ? void 0 : _b.call(logService, "[GlobalLocation] Fingerprint failed", err);
            return this.serviceFlow();
        }
    }
    async serviceFlow() {
        var _a, _b;
        try {
            const res = await fetch(this.serviceUrl, { cache: "no-store" });
            const data = await res.json();
            const location = new LocationInfo(data);
            this.locationData = location;
            this.saveToStorage(location);
            (_a = logService === null || logService === void 0 ? void 0 : logService.log) === null || _a === void 0 ? void 0 : _a.call(logService, "[GlobalLocation] Loaded location via API");
            return location;
        }
        catch (err) {
            (_b = logService === null || logService === void 0 ? void 0 : logService.error) === null || _b === void 0 ? void 0 : _b.call(logService, "[GlobalLocation] API failed", err);
            const stored = this.getFromStorage();
            this.locationData = stored !== null && stored !== void 0 ? stored : new LocationInfo({});
            return this.locationData;
        }
    }
    async setInformation() {
        const stored = this.getFromStorage();
        if (stored) {
            this.locationData = stored;
            return stored;
        }
        if (this.hasFingerprint()) {
            return this.fingerprintFlow();
        }
        return this.serviceFlow();
    }
    async update() {
        if (this.hasFingerprint()) {
            return this.fingerprintFlow();
        }
        return this.serviceFlow();
    }
    getLocationInfo() {
        var _a;
        return (_a = this.locationData) !== null && _a !== void 0 ? _a : this.getFromStorage();
    }
    getCountryCode() {
        var _a, _b;
        return (_b = (_a = this.getLocationInfo()) === null || _a === void 0 ? void 0 : _a.CountryCode) !== null && _b !== void 0 ? _b : "unknown";
    }
    getZipCode() {
        var _a, _b;
        return (_b = (_a = this.getLocationInfo()) === null || _a === void 0 ? void 0 : _a.Zip) !== null && _b !== void 0 ? _b : "unknown";
    }
    getIP() {
        var _a, _b;
        return (_b = (_a = this.getLocationInfo()) === null || _a === void 0 ? void 0 : _a.IpAddress) !== null && _b !== void 0 ? _b : null;
    }
    getIsEuMember() {
        var _a, _b;
        return (_b = (_a = this.getLocationInfo()) === null || _a === void 0 ? void 0 : _a.IsEuMember) !== null && _b !== void 0 ? _b : false;
    }
    getCity() {
        var _a, _b;
        return (_b = (_a = this.getLocationInfo()) === null || _a === void 0 ? void 0 : _a.City) !== null && _b !== void 0 ? _b : "unknown";
    }
    getState() {
        var _a, _b;
        return (_b = (_a = this.getLocationInfo()) === null || _a === void 0 ? void 0 : _a.State) !== null && _b !== void 0 ? _b : "unknown";
    }
    getContinentCode() {
        var _a, _b;
        return (_b = (_a = this.getLocationInfo()) === null || _a === void 0 ? void 0 : _a.ContinentCode) !== null && _b !== void 0 ? _b : "unknown";
    }
    getGuid() {
        return CookiesStorageService.get(StorageKeys.ConnextUserId, {
            expandKey: false,
            isSecureValue: false,
            useRootDomain: true
        });
    }
}
export const GlobalLocation = new GlobalLocationClass();
